document.addEventListener('click', function (event) {

  const button = event.target.closest('.size-chart__unit');
  if (!button) return;

  const chart = button.closest('.size-chart');
  if (!chart) return;

  const conversionType =
    chart.dataset.conversionType || 'none';

  const primaryBtn =
    chart.querySelector('[data-unit="primary"]');

  const conversionBtn =
    chart.querySelector('[data-unit="conversion"]');

  const cells =
    chart.querySelectorAll('[data-primary]');

  function convert(value) {

    value = parseFloat(value);

    if (isNaN(value)) return value;

    switch (conversionType) {

      case 'in_to_cm':
        return (value * 2.54).toFixed(1);

      case 'cm_to_in':
        return (value / 2.54).toFixed(1);

      default:
        return value;
    }
  }

  if (button.dataset.unit === 'primary') {

    primaryBtn?.classList.add('active');
    conversionBtn?.classList.remove('active');

    cells.forEach(cell => {
      cell.textContent = cell.dataset.primary;
    });

  }

  if (button.dataset.unit === 'conversion') {

    conversionBtn?.classList.add('active');
    primaryBtn?.classList.remove('active');

    cells.forEach(cell => {

      if (conversionType === 'none') {

        if (cell.dataset.conversion) {
          cell.textContent = cell.dataset.conversion;
        }

      } else {

        cell.textContent =
          convert(cell.dataset.primary);

      }

    });

  }

});